import { useState } from 'react';
import { Loader2 } from 'lucide-react';

interface InlineSelectProps {
  value: string;
  options: { value: string; label: string }[];
  onSave: (value: string) => Promise<void>;
  className?: string;
}

export function InlineSelect({ value, options, onSave, className = '' }: InlineSelectProps) {
  const [saving, setSaving] = useState(false);

  const handleChange = async (newValue: string) => {
    if (newValue === value) return;
    setSaving(true);
    try {
      await onSave(newValue);
    } finally {
      setSaving(false);
    }
  };

  if (saving) {
    return <Loader2 className="h-4 w-4 text-surface-400 animate-spin" />;
  }

  return (
    <select
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      className={`bg-surface-700 border border-surface-600 rounded-md px-2 py-1 text-sm text-surface-200
        focus:outline-none focus:ring-1 focus:ring-nexus-500 cursor-pointer hover:border-surface-500 ${className}`}
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
